<template>
  <div :style="{ marginTop }">
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd" clip-rule="evenodd" d="M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L4.75 3.68934L8.21967 0.21967C8.51256 -0.0732233 8.98744 -0.0732233 9.28033 0.21967C9.57322 0.512563 9.57322 0.987437 9.28033 1.28033L5.81066 4.75L9.28033 8.21967C9.57322 8.51256 9.57322 8.98744 9.28033 9.28033C8.98744 9.57322 8.51256 9.57322 8.21967 9.28033L4.75 5.81066L1.28033 9.28033C0.987437 9.57322 0.512563 9.57322 0.21967 9.28033C-0.0732233 8.98744 -0.0732233 8.51256 0.21967 8.21967L3.68934 4.75L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z" 
        :fill="fillBackgroundColor"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'CloseIcon',
  props: {
      width: {
          type: Number,
          default: 16
      },
      height: {
          type: Number,
          default: 16
      },
      fillBackgroundColor: {
          type: String,
          default: '#667488'
      },
      marginTop: {
          type: String,
          default: '2px'
      }
  },

  setup(props) {
      return props;
  }
}
</script>
